import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element }) => {

    const isSessionLoggedIn = sessionStorage.getItem('logined') === 'true';
    const isLocalLoggedIn = localStorage.getItem('logined') === 'true';
  
    const isLoggedIn = isSessionLoggedIn && isLocalLoggedIn;
  
    return isLoggedIn ? element : <Navigate to="/login" />;
  };
  

export default PrivateRoute;
